import React from 'react';

export const NotificationInfoIcon: React.FC<sharedComponents.SvgIcon> = ({
  color,
  width = '28px',
  height = '28px',
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    className={className}
  >
    <path
      d="M13 19.125C13.4832 19.125 13.875 18.7332 13.875 18.25C13.875 17.7668 13.4832 17.375 13 17.375C12.5168 17.375 12.125 17.7668 12.125 18.25C12.125 18.7332 12.5168 19.125 13 19.125Z"
      fill={color}
    />
    <path
      d="M12.5625 15.1875C12.5625 15.45 12.7375 15.625 13 15.625C13.2625 15.625 13.4375 15.45 13.4375 15.1875V7.3125C13.4375 7.05 13.2625 6.875 13 6.875C12.7375 6.875 12.5625 7.05 12.5625 7.3125V15.1875Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 0.75C6.2625 0.75 0.75 6.2625 0.75 13C0.75 19.7375 6.2625 25.25 13 25.25C19.7375 25.25 25.25 19.7375 25.25 13C25.25 6.2625 19.7375 0.75 13 0.75ZM13 1.625C19.3 1.625 24.375 6.7 24.375 13C24.375 19.3 19.3 24.375 13 24.375C6.7 24.375 1.625 19.3 1.625 13C1.625 6.7 6.7 1.625 13 1.625Z"
      fill={color}
    />
  </svg>
);
